/* eslint-disable import/no-mutable-exports */
import { CDN_STATIC_PROD, DOMAIN } from '@bfe/by-dynamic-domain';
/**
 * All site use this key to share language setting
 */

export var BYBIT_LANG_KEY = 'BYBIT_LANG_KEY';
/**
 * All site use this key to share guid. (unique id)
 */

export var BYBIT_GUID_KEY = '_by_l_g_d';
/**
 * All site can sue this key to get the user's theme preference.
 */

export var BYBIT_THEME_KEY = 'BYBIT_THEME_KEY';
export var BYBIT_LOGO_PATH = {
  dark: "".concat(CDN_STATIC_PROD, "/asset/image/logo-white.svg"),
  light: "".concat(CDN_STATIC_PROD, "/asset/image/logo-dark.svg")
};
export var BYBIT_APP_QR_CODE_PATH = "".concat(CDN_STATIC_PROD, "/assets/image/d-").concat(DOMAIN, ".png");
export var ADA_LOCALE_MAP = {
  'en-US': 'en',
  en: 'en',
  'zh-MY': 'zh',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'ru-RU': 'ru',
  'vi-VN': 'vi',
  'zh-TW': 'zh-tw',
  'zh-HK': 'zh-tw',
  'en-HK': 'en',
  'es-ES': 'es',
  'tr-TR': 'tr',
  'pt-BR': 'pt',
  'fr-FR': 'fr',
  'th-TH': 'th',
  'id-ID': 'id',
  'uk-UA': 'uk',
  'kk-KZ': 'kk',
  'ar-SA': 'ar',
  'hi-IN': 'hi',
  'fil-PH': 'fil',
  'pt-PT': 'pt',
  'es-MX': 'es',
  'es-AR': 'es',
  'es-419': 'es'
};
export var TRADING_VIEW_LOCALE_MAP = {
  'en-US': 'en',
  en: 'en',
  'zh-MY': 'zh',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'ru-RU': 'ru',
  'vi-VN': 'vi',
  'zh-TW': 'zh_TW',
  'zh-HK': 'zh_TW',
  'es-ES': 'es',
  'tr-TR': 'tr',
  'pt-BR': 'pt',
  'fr-FR': 'fr',
  'th-TH': 'th',
  'id-ID': 'id_ID',
  'uk-UA': 'en',
  'kk-KZ': 'en',
  'ar-SA': 'ar',
  'hi-IN': 'en',
  'fil-PH': 'en',
  'pt-PT': 'pt',
  'es-MX': 'es',
  'es-AR': 'es',
  'es-419': 'es'
};
var BYBIT_LANGUAGES = [{
  label: 'English',
  lang: 'EN',
  value: 'en'
}, // { label: 'English(US)', lang: 'EN', value: 'en-US' }, // en-US 下线
{
  label: 'Bahasa Indonesia',
  lang: 'ID',
  value: 'id-ID'
}, {
  label: 'Español (Internacional)',
  lang: 'ES',
  value: 'es-ES'
}, {
  label: 'Español (Latinoamérica)',
  lang: 'ES',
  value: 'es-419'
}, {
  label: 'Español (México)',
  lang: 'ES',
  value: 'es-MX'
}, {
  label: 'Español (Argentina)',
  lang: 'ES',
  value: 'es-AR'
}, {
  label: 'Filipino',
  lang: 'FIL',
  value: 'fil-PH'
}, // { label: 'Français', lang: 'FR', value: 'fr-FR' },
{
  label: 'қазақша',
  lang: 'KK',
  value: 'kk-KZ'
}, {
  label: 'Português (Brasil)',
  lang: 'BR',
  value: 'pt-BR'
}, {
  label: 'Português (Portugal)',
  lang: 'PT',
  value: 'pt-PT'
}, {
  label: 'Русский',
  lang: 'RU',
  value: 'ru-RU'
}, {
  label: 'Tiếng Việt',
  lang: 'VI',
  value: 'vi-VN'
}, {
  label: 'Türkçe',
  lang: 'TR',
  value: 'tr-TR'
}, {
  label: 'ไทย',
  lang: 'TH',
  value: 'th-TH'
}, {
  label: 'Українська',
  lang: 'UK',
  value: 'uk-UA'
}, {
  label: 'العربيه',
  lang: 'AR',
  value: 'ar-SA'
}, {
  label: 'हिंदी',
  lang: 'HI',
  value: 'hi-IN'
}, {
  label: '日本語',
  lang: 'JA',
  value: 'ja-JP'
}, // { label: '中文简体', lang: 'ZH', value: 'zh-CN' },
{
  label: '简体中文 (马来西亚)',
  lang: 'ZH',
  value: 'zh-MY'
}, {
  label: '繁體中文',
  lang: 'ZH',
  value: 'zh-TW'
}, {
  label: 'English(Netherlands)',
  lang: 'NL',
  value: 'nl-NL'
}, // 二期改为 Nederlands
{
  label: 'Polski',
  lang: 'PL',
  value: 'pl-PL'
}];
var regulatedSiteHosts = 'BYBIT';

if (typeof window !== 'undefined') {
  var hostname = window.location.hostname;

  regulatedSiteHosts = function () {
    if (/^[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname)) {
      return 'HKG';
    }

    if (/^[^.]+\.[^.]+\.ae$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.ae$/.test(hostname)) {
      return 'ARE';
    }

    return 'BYBIT';
  }();
}

if (regulatedSiteHosts === 'HKG') {
  BYBIT_LANGUAGES = [{
    label: '繁體中文 (香港)',
    lang: 'ZH',
    value: 'zh-HK'
  }, {
    label: 'English(Hong Kong)',
    lang: 'EN',
    value: 'en-HK'
  }];
}

export { BYBIT_LANGUAGES }; // 判断当前语言是否是 BYBIT_LANGUAGES 支持的语言
// eslint-disable-next-line arrow-body-style

export var getSupportLanguage = function getSupportLanguage(language) {
  return BYBIT_LANGUAGES.find(function (item) {
    return language === item.value;
  }) ? language : 'en';
};